import React, { useEffect, useState } from 'react';

const MediaAdminControls = ({ editMode, isAdmin, canEdit, toggleEditMode, onRefresh, onSetBackground }) => {
  const [customBackground, setCustomBackground] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('customBackground');
    setCustomBackground(stored === 'true');
  }, []);

  if (!isAdmin && !canEdit && !customBackground) return null;

  return (
    <div className="admin-controls">
      {(isAdmin || canEdit) && (
        <>
          <button className="btn admin-toggle-btn" onClick={toggleEditMode}>
            <img
              src={`/static/icons/${editMode ? 'lock-solid.svg' : 'pen-solid.svg'}`}
              alt="Edit Mode"
              className="icon"
            />
            {editMode ? 'Exit Edit Mode' : 'Enter Edit Mode'}
          </button>
          <button className="btn admin-refresh-btn" onClick={onRefresh}>
            <img
              src="/static/icons/arrows-rotate-solid.svg"
              alt="Refresh"
              className="icon"
            />
            Refresh
          </button>
        </>
      )}
      {customBackground && (
        <button className="btn admin-toggle-btn" onClick={onSetBackground}>
          <img
            src="/static/icons/image-solid.svg"
            alt="Set as Background"
            className="icon"
          />
          Set as Background
        </button>
      )}
    </div>
  );
};

export default MediaAdminControls;